import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';

import { buildListBlockRenderModel, countBlocks, takeBlocks } from './list-block-render-row.model';
import { LIST_BLOCK_BATCH_SIZE } from '../../../models/blocks/list-block-batch-size.constants';
import { SurveyEditorService } from '../../../services/survey-editor.service';

@Component({
  selector: 'empathy-list-blocks',
  templateUrl: 'list-blocks.component.html',
  styleUrls: ['./list-blocks.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ListBlocksComponent {
  blocks = inject(SurveyEditorService).surveyEditor$().blocks;

  visibleBlockCount$ = signal(LIST_BLOCK_BATCH_SIZE);

  renderRows$ = computed(() => buildListBlockRenderModel(this.blocks.all$()));
  visibleRows$ = computed(() => takeBlocks(this.renderRows$(), this.visibleBlockCount$()));
  hasMoreBlocks$ = computed(() => this.visibleBlockCount$() < countBlocks(this.renderRows$()));

  onLoadMore(): void {
    if (this.hasMoreBlocks$()) {
      this.visibleBlockCount$.update((count) => count + LIST_BLOCK_BATCH_SIZE);
    }
  }
}
